/** @jsxRuntime classic */

/** @jsx jsx */
import { jsx } from '@emotion/core'; // eslint-disable-next-line no-unused-vars

import React from 'react';
import Rodal from 'rodal';
import { useTranslation } from 'react-i18next';
import useMediaQuery from '../../../hooks/use-media-query';
import { ExclamationTriangleIcon } from '../../../icon';
import { Button, Colors } from '../../../core';
import { DivRow, DivColumn } from '../InputsUI';
import styles from './modalStyle';
import modalCustomStyle from './utils';
const {
  tdCarWeb: colors
} = Colors;
/**
 * Modal informativo que se muestra cuando el importador marca el checkbox de
 * "vehículo tramitado antes del Decreto Ejecutivo N.° 39724-MOPT-MINAE-S" en un
 * trámite de vehículos nuevos.
 *
 * En vehículos nuevos no existe prevención: si la ITV determina que el certificado
 * sí correspondía, el trámite se rechaza y queda cerrado sin posibilidad de reenvío.
 * Por eso el aviso, que es solo informativo (el valor ya quedó aplicado).
 *
 * @param {boolean} isVisible Determina si el modal está visible.
 * @param {function} onClose Se ejecuta al presionar "Entendido".
 */

export default function EmissionsCertificateWarning({
  isVisible,
  onClose
}) {
  const {
    t
  } = useTranslation();
  const {
    isMobile
  } = useMediaQuery();
  return jsx(Rodal, {
    visible: isVisible,
    showCloseButton: false,
    width: 781,
    height: 300,
    maxHeight: 374,
    closeOnEsc: true,
    onClose: onClose,
    customStyles: (modalCustomStyle({
      isMobile,
      width: 781,
      height: 300
    }), {
      borderRadius: 10
    })
  }, jsx("div", {
    css: [styles, {
      paddingTop: 48
    }]
  }, jsx(DivRow, {
    className: "modals-row"
  }, jsx(DivColumn, {
    className: "modals-column"
  }, jsx(ExclamationTriangleIcon, {
    className: "icon",
    css: {
      color: colors.cerulean
    }
  })), jsx(DivColumn, {
    className: "modals-column"
  }, jsx("h1", {
    className: "modals-title",
    style: {
      color: colors.prussianBlue
    }
  }, t('Certificado de emisiones')), jsx("p", {
    className: "modals-description"
  }, t('Al marcar esta casilla declara que el vehículo fue tramitado antes[ext]')))), jsx("div", {
    className: "button-container"
  }, jsx(Button, {
    size: "md-icon",
    className: "button blue",
    style: {
      background: colors.cerulean,
      color: colors.white,
      width: 150
    },
    onClick: onClose
  }, t('Entendido')))));
}